import { render, staticRenderFns } from "./MoveModel.vue?vue&type=template&id=3f1665c2&"
import script from "./MoveModel.vue?vue&type=script&lang=js&"
export * from "./MoveModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports